/* Random Number Generator */
function rendomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1) ) + min;
}

export function randomOrbit(radiusMin, radiusMax) {
    let alpha = rendomNumber(0, 360);
    let tehta = rendomNumber(0, 360);
    let radius = rendomNumber(radiusMin + 12.742, radiusMax + 12.742)
    x = radius * Math.cos(alpha) * Math.cos(tehta);
    y = radius * Math.cos(alpha) * Math.sin(tehta);
    z = radius * Math.sin(alpha);
    return [x, y, z]
}

export function randomOrbitTrack(radiusMin, radiusMax, trackWidth, rotation = 0) {
    let alpha = rendomNumber(0, 360);
    let width = rendomNumber(0+rotation, (trackWidth/4)+rotation)
    radius = rendomNumber(radiusMin + 12.742, radiusMax + 12.742)
    x = (radius * Math.cos(alpha) * Math.cos(1));
    y = (radius * Math.cos(alpha) * Math.sin(1))+width;
    z = (radius * Math.sin(alpha));
    return [x, y, z]
}